// extracted by mini-css-extract-plugin
module.exports = {"extra":"YAxisConfigurer_extra__Y8HQk"};